/* 2026-07-29 11:48
 * !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
 * ADD this file to your html right next to util.js !
 * !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
 * like this:
 *  <script src='../../../js/release/deposit/util.js'></script>
 *  <script src='../../../js/release/deposit/util.c2p.js'></script>
 */


/* Settings inside the theme:
 * app.pluginOpts.c2p = {
 *    consentCheckboxWrapperSelector: 'someCoolWrapperjQuerySelector', // optional, if not set the consent checkbox will be appended to PMINFO section
 * }
 */
app.util.c2p = (function() {
    var c2p = {
        flags: {
            getCardsCallDone: false,
            authenticateCallDone: false,
            isLastCardWithAllowedBrand: null,
            areEventListenersSet: false,
            checkoutWithNewCardDone: false,
            checkoutWithCardDone: false,
            authenticateCallInProgress: false,
            submitStoppedByPendingAuthentication: false
        },
        promises: {
            newCardFlowPromiseResolve: null,
            newCardFlowPromiseReject: null,
            existingCardFlowResolve: null,
            existingCardFlowReject: null
        },
        elements: {
            $iFrame: null,
            $lightbox: null,
            $lbxOverlay: null,
            $pmInfo: null,
            $consentCheckboxWrapper: null,
            consentCheckboxWrapperSelector: null
        },
        params: {
            srcDpaId: null,
            dpaName: null,
            locale: null,
            env: null,
            invalidCardIssuers: [],
            iframeSrc: null,
            merchantCategoryCode: null,
            merchantCountryCode: null,
            recognitionToken: null,
            acquirerData: null,
            lastEmailUsedForLookup: null
        },
        allowedBrands: ['master_card', 'maestro', 'visa', 'amex', 'discover_card'],
        brandsForInitCall: null,
        origin: document.location.origin,
        userCards: null,
        c2pAllowedCardBrands: [],
        iframeOrigin: null,

        recognitionTokenFromAuthCall: null,
        
        cardList: null,
        options: {},
        defaults: {
            hideableCardFormContainerSelectors: '.row.cc_card_number, #cvv_container'
        }
    };

    c2p.init = function(params) {
        if ((c2p.flags.getCardsCallDone || c2p.flags.authenticateCallDone) && c2p.elements.$iFrame.length) {
            return;
        }

        setInitParams();
        
        c2p.options = $.extend(true, {}, c2p.defaults, app.pluginOpts.c2p || {});

        if (!c2p.elements.$iFrame.length) {
            c2p.iframeOrigin = null;
            c2p.appendIframe();
            c2p.showPopup();
        }
        else { // when a transaction with c2p is completed, check if he added a new card
            c2p.showPopup();
            c2p.sendPostMessage("callGetCards");
        }

        c2p.setEventListeners();

        function setInitParams() {
            c2p.params.srcDpaId = params.srcDpaId;
            c2p.params.dpaName = params.dpaName;
            c2p.params.locale = params.locale;
            c2p.params.env = params.env;
            c2p.params.invalidCardIssuers = params.invalidCardIssuers;
            c2p.params.iframeSrc = params.iframeSrc + '?srcDpaId=' + c2p.params.srcDpaId + '&locale=' + c2p.params.locale +
                '&enterCardManuallyText=' + encodeURIComponent(app.msg.c2p_enter_card_manually || '') +
                '&notYouFormTitle=' + encodeURIComponent(app.msg.c2p_not_you_form_title || '') +
                '&notYouEmailPlaceholder=' + encodeURIComponent(app.msg.c2p_not_you_email_placeholder || '') +
                '&notYouContinueText=' + encodeURIComponent(app.msg.c2p_not_you_continue || '') +
                '&notYouNoProfileText=' + encodeURIComponent(app.msg.c2p_not_you_no_profile || '') +
                '&notYouInvalidEmailText=' + encodeURIComponent(app.msg.invalid_email || '') +
                '&notYouDisclosureLabelText=' + encodeURIComponent(app.msg.c2p_not_you_disclosure_label || '') +
                '&notYouDisclosureText=' + encodeURIComponent(app.msg.c2p_not_you_disclosure || '') +
                '&templateResourcesPath=' + encodeURIComponent(app.config.templateResourcesPath || '') +
                '&isNative=' + encodeURIComponent(app.config.isNative || false);
            c2p.params.merchantCategoryCode = params.merchantCategoryCode || '';
            c2p.params.merchantCountryCode = params.merchantCountryCode || '';
            c2p.params.recognitionToken = params.recognitionToken;
            c2p.params.acquirerData = params.acquirerData || null;

            c2p.elements.consentCheckboxWrapperSelector = params.consentCheckboxWrapperSelector || null;
            c2p.elements.$pmInfo = $('.PMINFO');

            c2p.elements.$consentCheckboxWrapper = c2p.elements.consentCheckboxWrapperSelector && $(c2p.elements.consentCheckboxWrapperSelector);
            if ((!c2p.elements.$consentCheckboxWrapper || !c2p.elements.$consentCheckboxWrapper.length) && c2p.elements.$pmInfo.length) {
                c2p.elements.$consentCheckboxWrapper = c2p.elements.$pmInfo;
            }
            else if (!c2p.elements.$pmInfo.length) {
                console.warn('PMINFO element not found. Consent checkbox will not be displayed for card brands allowed for C2P.');
            }

            c2p.elements.$iFrame = $('#c2p_iframe');
            c2p.elements.$lightbox = $('#lightbox_c2p');
            c2p.brandsForInitCall = c2p.getCardsForC2P();

            c2p.recognitionTokenFromAuthCall = null;
        }
    };

    // check this function on existing user flow development
    c2p.continueAfterGetCardsOrAuthenticate = function() {
        c2p.elements.$pmInfo = $('.PMINFO');
        c2p.elements.$consentCheckboxWrapper = c2p.elements.consentCheckboxWrapperSelector && $(c2p.elements.consentCheckboxWrapperSelector);
        if ((!c2p.elements.$consentCheckboxWrapper || !c2p.elements.$consentCheckboxWrapper.length) && c2p.elements.$pmInfo.length) {
            c2p.elements.$consentCheckboxWrapper = c2p.elements.$pmInfo;
        }
        else if (!c2p.elements.$pmInfo.length) {
            console.warn('PMINFO element not found. Consent checkbox will not be displayed for card brands allowed for C2P.');
        }

        if (c2p.userCards && c2p.userCards.length) {
            app.util.c2pCardListPlugIn.init(app.pluginOpts.c2pCardList || {}, c2p.userCards);
        } else {
            c2p.handleCreateRemoveConsentChbs(app.lastCardDetected);
        }
    };

    c2p.sendInitGetCardsMessage = function() {
        var data = {
            env: c2p.params.env,
            srcDpaId: c2p.params.srcDpaId,
            dpaName: c2p.params.dpaName,
            locale: c2p.params.locale,
            brands: c2p.brandsForInitCall,
            use3dsv2: app.config.use3dsv2,
            recognitionToken: c2p.params.recognitionToken
        };

        if (!app.config.isOpenAmount) {
            data.transactionAmount = c2p.getTransactionAmountData();
        }

        c2p.sendPostMessage("initAndGetCardsCalls", data);
    };

    c2p.sendIdLookupMessage = function() {
        c2p.sendPostMessage("idLookupCall", {
            email:  $('#email').val() || app.config.user.payer_email || '',
            // phone:  $('#phone1').val() || app.config.user.phone || ''
        });
    };

    c2p.sendAuthenticateMessage = function(emailOverride, skipPhone) {
        c2p.flags.authenticateCallInProgress = true;
        c2p.sendPostMessage("authenticateCall", {
            email: emailOverride || $('#email').val() || app.config.user.payer_email || '',
            phone: skipPhone ? '' : ($('#phone1').val() || app.config.user.phone || '')
        });
    };

    c2p.getTransactionAmountData = function() {
        var currency = app.lastSelectedCurrency || app.currency;
        var rawAmount = app.lastSelectedAmount;
        var roundingScale = !isNaN(parseInt(app.roundingScale, 10)) ? parseInt(app.roundingScale, 10) : 2;

        if (rawAmount === undefined || rawAmount === null || rawAmount === '') {
            rawAmount = $('#item_amount_1').val() || app.amount;
        }

        rawAmount = parseFloat(parseFloat(rawAmount).toFixed(roundingScale));

        if (!currency || isNaN(rawAmount)) {
            return null;
        }

        return {
            transactionAmount: rawAmount,
            transactionCurrencyCode: currency
        };
    };

    c2p.doCheckoutWithNewCard = function() {
        var data = collectCardAndUserData();
        $.unblockUI();
        c2p.showPopup();
        c2p.sendPostMessage("c2pEncryptCardAndCheckoutWithNewCard", data);

        return new Promise(function(resolve, reject){
            c2p.promises.newCardFlowPromiseResolve = resolve;
            c2p.promises.newCardFlowPromiseReject = reject;
        });

        function collectCardAndUserData() {
            var cardHolderNameArr = $('#cc_name_on_card').val().split(' ');
            var firstName = cardHolderNameArr[0];
            var lastName = cardHolderNameArr.length > 1 ? cardHolderNameArr.slice(1).join(' ') : '';
            var billingName = ((app.config.user.firstName || $('#first_name').val() || firstName || '') + ' ' + (app.config.user.lastName || $('#last_name').val() || lastName || '')).trim();

            var address1 = $('#address_line1').val();
            var address2 = $('#address_line2').val();
            var address3 = $('#address_line3').val();
            var city     = $('#city').val();
            var state    = $('#state').val();
            var zip      = $('#zip').val();
            var country  = $('#country').val();

            var billingAddress = {};
            if (billingName) { billingAddress.name        = billingName; }
            if (address1)    { billingAddress.line1       = address1; }
            if (address2)    { billingAddress.line2       = address2; }
            if (address3)    { billingAddress.line3       = address3; }
            if (city)        { billingAddress.city        = city; }
            if (state)       { billingAddress.state       = state; }
            if (zip)         { billingAddress.zip         = zip; }
            if (country)     { billingAddress.countryCode = country; }

            var cardAndUserDetails = {
                primaryAccountNumber: $('#cc_card_number').val().replace(/ /g, ''),
                panExpirationMonth: $('#cc_exp_month').val(),
                panExpirationYear: $('#cc_exp_year').val(),
                cardSecurityCode: $('#cc_cvv2').val(),
                cardholderFirstName: firstName,
                cardholderLastName: lastName
            };

            if (!$.isEmptyObject(billingAddress)) {
                cardAndUserDetails.billingAddress = billingAddress;
            }

            var data = {
                cardAndUserDetails: cardAndUserDetails,
                email: c2p.lastEmailUsedForLookup || $('#email').val() || app.config.user.payer_email || '',
                rememberMeToggle: $('#c2p_remember_me_chb').is(':checked'),
                country: c2p.params.merchantCountryCode || '',
                transactionAmount: c2p.getTransactionAmountData(),
                use3dsv2: app.config.use3dsv2,
                acquirerData: c2p.params.acquirerData || null,
                merchantCategoryCode: c2p.params.merchantCategoryCode || ''
            };

            var c2pPhoneCountryCode = app.config.c2pPhoneCountryCode || '';
            var phoneNumber = app.config.user.phone || '';
            if (c2pPhoneCountryCode && phoneNumber) {
                data.phoneObj = {
                    countryCode: c2pPhoneCountryCode,
                    phoneNumber: phoneNumber
                };
            }

            return data;
        }
    };

    c2p.doCheckoutWithCard = function() {
        var data = collectSelectedCardData();

        if (!data) {
            return new Promise(function(resolve, reject){
                reject('No card selected');
            });
        }

        $.unblockUI();
        c2p.showPopup();

        c2p.sendPostMessage("c2pCheckoutWithCard", data);

        return new Promise(function(resolve, reject){
            c2p.promises.existingCardFlowResolve = resolve;
            c2p.promises.existingCardFlowReject = reject;
        });

        function collectSelectedCardData() {
            var $selectedCard = $('#c2p_cards_list input[name="cardList"]:checked');
            var selectedCardId = $selectedCard.val();
            var selectedCardData = c2p.findUserCardBySrcDigitalCardId(selectedCardId);

            if (!selectedCardData) {
                return null;
            }

            var data = {
                srcDigitalCardId: selectedCardId,
                country: c2p.params.merchantCountryCode || '',
                transactionAmount: c2p.getTransactionAmountData(),
                use3dsv2: app.config.use3dsv2,
                acquirerData: c2p.params.acquirerData || null,
                merchantCategoryCode: c2p.params.merchantCategoryCode || ''
            };
            return data;
        }
    };

    c2p.findUserCardBySrcDigitalCardId = function(srcDigitalCardId) {
        if (!c2p.userCards || !c2p.userCards.length) {
            return null;
        }
        var foundCard = _.find(c2p.userCards,function(card) {
            return card.srcDigitalCardId === srcDigitalCardId;
        });
        return foundCard || null;
    };

    c2p.onMessage = function(data, origin) {
        if (data && data.message === 'c2pIframeReady' && !c2p.iframeOrigin && window.origin === origin) {
            c2p.iframeOrigin = origin;
            c2p.sendInitGetCardsMessage();
            return;
        }

        if (origin !== c2p.iframeOrigin || !data) {
            return;
        }
        else if (data.message === 'c2pInitSuccess' && data.payload) {
            c2p.c2pAllowedCardBrands = data.payload.availableCardBrands || [];
            c2p.normalizeAllowedCardBrands();
        }
        else if (data.message === 'c2pCardsReceived') {
            c2p.onCardsReceivedMsg(data);
        }
        else if (
            data.message === 'c2pScriptLoadError' ||
            data.message === 'c2pInitError' ||
            data.message === 'c2pGetCardsError' || 
            data.message === 'c2pSignOutError' ||
            data.message === 'c2pLearnMoreClosed') {
            c2p.hidePopup();
        }
        else if (data.message === 'c2pIdLookupError') {
            if (data.payload && data.payload.isNotYouFlow) {
                c2p.elements.$lightbox.addClass('c2p-not-you-form-visible');
                c2p.sendPostMessage('c2pNotYouIdLookupNoProfile');
            } else {
                c2p.hidePopup();
            }
        }
        else if (data.message === 'c2pIdLookupSuccess') {
            c2p.onIdLookupSuccess(data);
        }
        else if (data.message === 'c2pAuthenticateSuccess') {
            c2p.onAuthSuccessfulMsg(data);
        } else if (data.message === 'c2pAuthenticateUnsuccessful') { // new user for mastercard
            c2p.onAuthUnsuccessfulMsg();
        } else if (data.message === 'c2pAuthenticateError') {
            c2p.flags.authenticateCallInProgress = false;
            c2p.hidePopup();
        } else if (data.message === 'c2pCheckoutWithNewCardSuccess') {
            c2p.onCheckoutWithNewCardSuccess(data);
        } else if (data.message === 'c2pCheckoutWithNewCardCancelByUser') {
            c2p.hidePopup();
            c2p.handlePromiseForNewCardFlow(false);
        } else if (data.message === 'c2pEncryptCardOrCheckoutWithNewCardError') {
            c2p.hidePopup();
            c2p.handlePromiseForNewCardFlow(false, null, true);
        } else if (data.message === 'c2pCheckoutWithCardSuccess') {
            c2p.onCheckoutWithCardSuccess(data);
        } else if (data.message === 'c2pCheckoutWithCardError' || data.message === 'c2pCheckoutWithCardChangeAddCard' || data.message === 'c2pCheckoutWithCardCancelByUser') {
            c2p.hidePopup();
            c2p.handlePromiseForExistingCardFlow(false);
        } else if (data.message === 'c2pEnterCardManually') {
            if (data.payload && data.payload.email) {
                c2p.lastEmailUsedForLookup = data.payload.email;
                c2p.flags.authenticateCallInProgress = false;
            }
            c2p.hidePopup();
        } else if (data.message === 'c2pNotYouFormShown') {
            c2p.elements.$lightbox.addClass('c2p-not-you-form-visible');
        } else if (data.message === 'c2pNotYouFormHidden') {
            c2p.elements.$lightbox.removeClass('c2p-not-you-form-visible');
        } else if (data.message === 'c2pSignOutDone') {
            c2p.onSignOutDone();
        }
    };

    c2p.setEventListeners = function() {
        if (!c2p.flags.areEventListenersSet) {
            c2p.flags.areEventListenersSet = true;
            
            pubsub.subscribe('app.event.cardBrandChanged', function(data) {
                if (app.lastSelectedMethodId === 'cc_card' || app.lastSelectedMethodId === 'dc_card') {
                    c2p.handleCreateRemoveConsentChbs(data.newBrand);
                }
            });
            
            pubsub.subscribe('app.event.c2pCardList.CardChanged', c2p.cardListOnCardChange);
            
            // After a successful C2P checkout, checkoutWithCardDone / checkoutWithNewCardDone are set
            // to true so that isExistingCardFlow() / isNewCardFlow() short-circuit and the collected
            // C2P payload can be reused during the form submission (e.g. on a 3DS redirect-back).
            // Once the form has actually been submitted we must reset these flags so that any
            // subsequent transaction starts a fresh C2P flow rather than reusing stale state.
            pubsub.subscribe('post-form-submit', function() {
                if (c2p.flags.checkoutWithCardDone || c2p.flags.checkoutWithNewCardDone) {
                    c2p.flags.checkoutWithCardDone = false;
                    c2p.flags.checkoutWithNewCardDone = false;
                }
            });

            pubsub.subscribe('app.event.c2pCardList.NotYouClicked', c2p.handleNotYouForRecognizedUser);
        }
    };

    // event handlers
    c2p.onCardsReceivedMsg = function(data) {
        c2p.flags.getCardsCallDone = true;
        c2p.userCards = (data.payload && data.payload.cards) || [];
        if (c2p.userCards.length) {
            app.util.c2pCardListPlugIn.init(app.pluginOpts.c2pCardList || {}, c2p.userCards);
            c2p.hidePopup();
        }
        else {
            c2p.sendIdLookupMessage();
        }
    };

    c2p.onAuthSuccessfulMsg = function(data) {
        var preselectEnterCardManually = false;
        c2p.flags.authenticateCallInProgress = false;
        c2p.recognitionTokenFromAuthCall = data.payload.recognitionToken ? data.payload.recognitionToken : null;
        if (c2p.flags.submitStoppedByPendingAuthentication) {
            preselectEnterCardManually = true;
        }
        
        c2p.flags.authenticateCallDone = true;
        c2p.userCards = (data.payload && data.payload.cards) || [];

        if (c2p.userCards.length) {
            var options = app.pluginOpts.c2pCardList || {};
            options.preselectEnterCardManually = preselectEnterCardManually;
            app.util.c2pCardListPlugIn.init(options, c2p.userCards);
        }
        if (c2p.flags.submitStoppedByPendingAuthentication) {
            c2p.flags.submitStoppedByPendingAuthentication = false;
            c2p.createConsentChb(true, app.lastCardDetected);
            $('#continueButton').click();
        }
        else {
            c2p.hidePopup();
        }
    };

    c2p.onIdLookupSuccess = function(data) {
        if (data.payload.consumerPresent) {
            c2p.sendAuthenticateMessage(data.payload.requestEmail || null, !!data.payload.isNotYouFlow);
        }
        else if (data.payload.isNotYouFlow) {
            c2p.elements.$lightbox.addClass('c2p-not-you-form-visible');
            c2p.sendPostMessage('c2pNotYouIdLookupNoProfile');
        }
        else {
            c2p.hidePopup();
        }
    };

    c2p.onAuthUnsuccessfulMsg = function() {
        c2p.flags.authenticateCallInProgress = false;
        c2p.flags.authenticateCallDone = true;
        c2p.hidePopup();
    };

    c2p.onCheckoutWithNewCardSuccess = function(data) {
        if (c2p.promises.newCardFlowPromiseResolve) {
            c2p.handlePromiseForNewCardFlow(true, data);
            c2p.hidePopup();
        }
    };

    c2p.onCheckoutWithCardSuccess = function(data) {
        if (c2p.promises.existingCardFlowResolve) {
            c2p.handlePromiseForExistingCardFlow(true, data);
            c2p.hidePopup();
        }
    };

    c2p.handleNotYouForRecognizedUser = function() {
        c2p.showPopup();
        c2p.sendPostMessage('c2pSignOut');
        c2p.enableCcCardFields();
    };

    c2p.onSignOutDone = function() {
        $('#c2p_card_list_wrapper').remove();
        c2p.userCards = null;
        c2p.flags.authenticateCallDone = false;
        c2p.flags.submitStoppedByPendingAuthentication = false;
        c2p.recognitionTokenFromAuthCall = null;
        c2p.sendPostMessage('c2pShowNotYouForm');
    };
    // event handlers END

    // helpers
    c2p.appendIframe = function() {
        var lbxTemplate = _.template('<div id="lightbox_c2p" class="hidden"><div class="lightbox-content"></div></div>');
        var lbxOverlayTemplate = _.template('<div id="lightbox_overlay_c2p"></div>');
        var iFrameTemplate = _.template('<iframe src="<%= iframeSrc %>" id="c2p_iframe" name="c2p_iframe" style="overflow:hidden;width:100%;height:100%;"></iframe>');

        if (c2p.elements.$lightbox.length) {
            c2p.elements.$lightbox.find('.lightbox-content').empty();
        }
        else {
            app.bodyElm.append(lbxTemplate());
            app.bodyElm.append(lbxOverlayTemplate());

            c2p.elements.$lightbox = $('#lightbox_c2p');
            c2p.elements.$lbxOverlay = $('#lightbox_overlay_c2p');
        }


        c2p.elements.$lightbox.find('.lightbox-content').append(iFrameTemplate({ iframeSrc: c2p.params.iframeSrc }));
        c2p.elements.$iFrame = $('#c2p_iframe');
    };

    c2p.getCardsForC2P = function() {
        var allowedBrands = [];

        c2p.allowedBrands.forEach(function(brand) {
            if (!c2p.params.invalidCardIssuers.includes(brand)) {
                var c2pBrand = c2p.convertBrandToC2PFormat(brand);
                allowedBrands.push(c2pBrand);
            }
        });
        
        return allowedBrands;
    };

    c2p.convertBrandToC2PFormat = function(brand) {
        if (brand === 'master_card') {
            return 'mastercard';
        }
        else if (brand === 'discover_card') {
            return 'discover';
        }
        return brand;
    };

    c2p.showPopup = function() {
        c2p.elements.$lightbox.removeClass('hidden');
        c2p.elements.$lbxOverlay.show();
    };

    c2p.hidePopup = function() {
        c2p.elements.$lightbox.addClass('hidden').removeClass('c2p-not-you-form-visible');
        c2p.elements.$lbxOverlay.hide();
    };

    c2p.normalizeAllowedCardBrands = function () {
        for (var i = 0; i < c2p.c2pAllowedCardBrands.length; i++) {
            if (c2p.c2pAllowedCardBrands[i] === 'mastercard') {
                c2p.c2pAllowedCardBrands[i] = 'master_card';
            }
            else if (c2p.c2pAllowedCardBrands[i] === 'discover') {
                c2p.c2pAllowedCardBrands[i] = 'discover_card';
            }
        }
    }

    c2p.createConsentChb = function(forceSelectConsent, cardBrand) {
        c2p.removeConsentChb();
        var c2pBrand = c2p.convertBrandToC2PFormat(cardBrand);
        // Existing C2P customer adding a new card: show a single disclosure toggle instead of
        // the new-customer consent + remember-me toggles (US 1278307).
        if (c2p.userCards && c2p.userCards.length) {
            c2p.createExistingUserConsentChb(forceSelectConsent, cardBrand);
        }
        else {
            c2p.createNewUserConsentChb(forceSelectConsent, c2pBrand);
        }
    };

    c2p.createNewUserConsentChb = function(forceSelectConsent, c2pBrand) {
        var consentTemplate = _.template(
            '<div id="c2p-consent-wrapper" class="c2p-consent-wrapper row">' +
                '<input type="checkbox" id="c2p_consent_chb" class="toggle_checkbox" <% if (forceSelectConsent) { %>checked<% } %> />' +
                '<label for="c2p_consent_chb"><%= t("c2p_consent") %> ' +
                    '<span class=text data-no="<%- t(\"checkbox_no\") %>" data-yes="<%- t(\"checkbox_yes\") %>"></span>' +
                '</label>' +
                '<div class="c2p-additional-info"><%= t("c2p_consent_additional_info") %></div>' +
            '</div>');
        var consentTemplateAmexDiscover = _.template(
            '<div id="c2p-consent-wrapper" class="c2p-consent-wrapper row">' +
                '<input type="checkbox" id="c2p_consent_chb" class="toggle_checkbox" <% if (forceSelectConsent) { %>checked<% } %> />' +
                '<label for="c2p_consent_chb"><% if (cardBrand === "amex") { %><%= t("c2p_consent_amex") %><% } else { %><%= t("c2p_consent_discover") %><% } %> ' +
                    '<span class=text data-no="<%- t(\"checkbox_no\") %>" data-yes="<%- t(\"checkbox_yes\") %>"></span>' +
                '</label>' +
            '</div>');
        var rememberMeTemplate = _.template(
            '<div id="c2p-remember-me-wrapper" class="c2p-remember-me-wrapper row <% if (!forceSelectConsent) { %>hidden<% } %>">' +
                '<input type="checkbox" id="c2p_remember_me_chb" class="toggle_checkbox" />' +
                '<label for="c2p_remember_me_chb"><%- t("c2p_remember_me") %>' +
                    '<span class=text data-no="<%- t(\"checkbox_no\") %>" data-yes="<%- t(\"checkbox_yes\") %>"></span>' +
                '</label>' +
                '<div class="c2p-additional-info"><% if (cardBrand === "visa") { %><%= t("c2p_remember_me_terms_and_notice_visa") %><% } else { %><%= t("c2p_remember_me_terms_and_notice") %><% } %></div>' +
            '</div>');
        var payload = {
            forceSelectConsent: forceSelectConsent,
            cardBrand: c2pBrand
        };

        if (c2pBrand === 'amex' || c2pBrand === 'discover') {
            c2p.elements.$consentCheckboxWrapper.append(consentTemplateAmexDiscover(payload));
        }
        else {
            c2p.elements.$consentCheckboxWrapper.append(consentTemplate(payload));
        }

        c2p.elements.$consentCheckboxWrapper.off('click', '.c2p-learn-more-link').on('click', '.c2p-learn-more-link', function(e) {
            e.preventDefault();
            c2p.showPopup();
            c2p.sendPostMessage('c2pShowLearnMore');
        });
        
        if (c2pBrand !== 'amex' && c2pBrand !== 'discover') {
            c2p.elements.$consentCheckboxWrapper.append(rememberMeTemplate(payload));
            
            var $consent = $('#c2p_consent_chb');
            var $rememberMeWrapper = $('#c2p-remember-me-wrapper');
            
            $consent.on('change', function() {
                if ($consent.is(':checked')) {
                    $rememberMeWrapper.removeClass('hidden');
                }
                else {
                    $rememberMeWrapper.addClass('hidden');
                }
                app.recalcUserDetailsArea(null, true);
            });
        }
    };

    c2p.createExistingUserConsentChb = function(forceSelectConsent, cardBrand) {
        var merchantName = c2p.params.dpaName || '';
        var brand = cardBrand || app.lastCardDetected || '';

        var existingUserConsentTemplate = _.template(
            '<div id="c2p-consent-wrapper" class="c2p-consent-wrapper row">' +
                '<input type="checkbox" id="c2p_consent_chb" class="toggle_checkbox" <% if (forceSelectConsent) { %>checked<% } %> />' +
                '<label for="c2p_consent_chb"><%- t("c2p_existing_user_consent", [merchantName, t(cardBrand)]) %> ' +
                    '<span class=text data-no="<%- t(\"checkbox_no\") %>" data-yes="<%- t(\"checkbox_yes\") %>"></span>' +
                '</label>' +
            '</div>');

        c2p.elements.$consentCheckboxWrapper.append(existingUserConsentTemplate({
            forceSelectConsent: forceSelectConsent,
            merchantName: merchantName,
            cardBrand: brand
        }));
    };

    c2p.removeConsentChb = function() {
        $('#c2p-consent-wrapper').remove();
        $('#c2p-remember-me-wrapper').remove();
    };

    c2p.handleCreateRemoveConsentChbs = function(cardBrand) {
        var brandAllowed = false;

        if (cardBrand === 'none') {
            c2p.removeConsentChb();
            app.recalcUserDetailsArea(null, true);
            c2p.flags.isLastCardWithAllowedBrand = false;
            return;
        }

        for (var i = 0; i < c2p.c2pAllowedCardBrands.length; i++) {
            if (c2p.c2pAllowedCardBrands[i] === cardBrand) {
                brandAllowed = true;
                break;
            }
        }

        c2p.flags.isLastCardWithAllowedBrand = brandAllowed;

        if (brandAllowed) {
            c2p.createConsentChb(false, cardBrand);
        }
        else {
            c2p.removeConsentChb();
        }
        app.recalcUserDetailsArea(null, true);
    };

    c2p.disableConsentChb = function() {
        $('#c2p_consent_chb').attr('disabled', true);
        $('#c2p_remember_me_chb').attr('disabled', true);
    };

    c2p.isNewCardFlow = function() {
        var userWantToUseC2P = $('#c2p_consent_chb').is(':checked');
        var $selectedCard = $('#c2p_cards_list input[name="cardList"]:checked');
        return c2p.flags.checkoutWithNewCardDone || (   
            c2p.flags.isLastCardWithAllowedBrand && 
            userWantToUseC2P && 
            c2p.flags.getCardsCallDone && 
            (
                !c2p.userCards ||
                !c2p.userCards.length || 
                ($selectedCard.length && $selectedCard.val() === "manual_entry")
            )
        );
    };

    c2p.isExistingCardFlow = function() {
        var $selectedCard = $('#c2p_cards_list input[name="cardList"]:checked');
        return c2p.flags.checkoutWithCardDone || (
            c2p.flags.getCardsCallDone &&
            c2p.userCards &&
            c2p.userCards.length &&
            $selectedCard.length &&
            $selectedCard.val() !== "manual_entry"
        );
    };
    
    c2p.isCurrentFlowC2P = function() {
        return  (app.lastSelectedMethodId === 'cc_card' || app.lastSelectedMethodId === 'dc_card') &&
                app.config.pmSettings.c2p && app.config.pmSettings.c2p.enabled &&
                (c2p.isNewCardFlow() || c2p.isExistingCardFlow());
    };

    c2p.disableCcCardFields = function() {
        app.util.handleCardHolderNameVisibility(app.lastCardDetected, true);
        app.util.disableField('cc_card_number');
        $(c2p.options.hideableCardFormContainerSelectors).addClass('hidden');
        app.util.disableField('expiration_period', true);
        app.util.handleCvvVisibility(app.lastCardDetected, '', true);
        app.util.c2p.removeConsentChb();
    };

    c2p.enableCcCardFields = function() {
        app.util.handleCardHolderNameVisibility(app.lastCardDetected);
        app.util.enableField('cc_card_number');
        $(c2p.options.hideableCardFormContainerSelectors).removeClass('hidden');
        app.util.enableField('expiration_period', true);
        app.util.handleCvvVisibility(app.lastCardDetected, '');
        c2p.handleCreateRemoveConsentChbs(app.lastCardDetected);
    };

    c2p.handlePromiseForNewCardFlow = function(isResolve, data, fallbackToPlainCard) {
        if (isResolve) {
            c2p.promises.newCardFlowPromiseResolve(data.payload);
            c2p.flags.getCardsCallDone = false;
            c2p.flags.authenticateCallDone = false;
            c2p.flags.checkoutWithNewCardDone = true;
        } else if (fallbackToPlainCard) {
            c2p.promises.newCardFlowPromiseReject({ fallbackToPlainCard: true });
        } else {
            c2p.promises.newCardFlowPromiseReject();
        }

        c2p.promises.newCardFlowPromiseResolve = null;
        c2p.promises.newCardFlowPromiseReject = null;
    };

    c2p.handlePromiseForExistingCardFlow = function(isResolve, data) {
        if (isResolve) {
            c2p.promises.existingCardFlowResolve(data.payload);
            c2p.flags.getCardsCallDone = false;
            c2p.flags.authenticateCallDone = false;
            c2p.flags.checkoutWithCardDone = true;
        } else {
            c2p.promises.existingCardFlowReject();
        }

        c2p.promises.existingCardFlowResolve = null;
        c2p.promises.existingCardFlowReject = null;
    };

    c2p.sendPostMessage = function(message, params) {
        var obj = {
            message: message
        };
        if (params) {
            obj.params = params;
        }
        c2p.elements.$iFrame[0].contentWindow.postMessage(JSON.stringify(obj), c2p.iframeOrigin);
    }
    // helpers END

    c2p.loadCardList = function() {
        if (
            (app.lastSelectedMethodId === 'cc_card' || app.lastSelectedMethodId === 'dc_card') &&
            app.config.pmSettings.c2p.enabled &&
            (c2p.flags.getCardsCallDone || c2p.flags.authenticateCallDone) &&
            c2p.elements.$iFrame.length
        ) {
            c2p.continueAfterGetCardsOrAuthenticate();
        }
    };

    c2p.cardListOnCardChange = function(data) {
        if (data && data.selectedCardId) {
            if (data.selectedCardId === "manual_entry") {
                c2p.enableCcCardFields();
            }
            else {
                c2p.disableCcCardFields();
            }
            // app.recalcUserDetailsArea();
        }
    };

    c2p.selectFlowAndSubmit = function(customAction, silent, isIframe) {
        if (c2p.isNewCardFlow()) {
            if (c2p.flags.authenticateCallInProgress) {
                c2p.flags.submitStoppedByPendingAuthentication = true;
                c2p.showPopup();
                c2p.sendPostMessage('c2pShowOTP');
                return;
            }
            c2p.doCheckoutWithNewCard().then(function(payload) {
                c2p.disableConsentChb();

                app.util.addTmpFormData({
                    c2pData: JSON.stringify({
                        c2pCheckoutData: payload,
                        c2pDataSource: 'checkoutWithNewCard'
                    })
                });

                submitInIframe(customAction, silent);
            })
            .catch(function(reason) {
                if (reason && reason.fallbackToPlainCard) {
                    c2p.disableConsentChb();
                    $('#c2p_consent_chb').prop('checked', false);
                    c2p.flags.checkoutWithNewCardDone = false;
                    submitInIframe(customAction, silent);
                } // else do nothing here, the popup is already closed and the user can decide what to do next
            });
        }
        else if (c2p.isExistingCardFlow()) {
            c2p.doCheckoutWithCard().then(function(payload) {
                if (c2p.recognitionTokenFromAuthCall && !payload.recognitionToken) {
                    payload.recognitionToken = c2p.recognitionTokenFromAuthCall;
                }
                app.util.addTmpFormData({
                    c2pData: JSON.stringify({
                        c2pCheckoutData: payload,
                        c2pDataSource: 'checkoutWithCard'
                    })
                });

                submitInIframe(customAction, silent);
            });
        }
        else {
            // not c2p flow
            submitInIframe(customAction, silent);
        }
    };

    return {
        init                         : c2p.init,
        hidePopup                    : c2p.hidePopup,
        onMessage                    : c2p.onMessage,
        selectFlowAndSubmit          : c2p.selectFlowAndSubmit,
        loadCardList                 : c2p.loadCardList,
        removeConsentChb             : c2p.removeConsentChb,
        isCurrentFlowC2P             : c2p.isCurrentFlowC2P
    };
})();

app.util.c2pCardListPlugIn = (function() {
    /* Settings inside the theme:
     * app.pluginOpts.c2pCardList = {
     *    containerSelector: 'someCoolContainerjQuerySelector', // optional, if not set the card list will be prepended to PMINFO section
     * }
     */
    var c2pCardList = {};
    var defaults = {
        numberOfVisibleCards: 1,
        templates: {
            wrapper: '<div id="c2p_card_list_wrapper"></div>',
            notYouBtnTemplate:
                '<div class="c2p-not-you-recognized-wrapper">' +
                    '<button type="button" class="c2p-not-you-recognized-btn"><%= t("c2p_not_your_cards_btn") %></button>' +
                '</div>',
            cardsTemplate: '<ul id="c2p_cards_list" class="c2p_cards_list"></ul>',
            cardTemplate:
                '<li class="c2p_card<% if (isHidden) { %> hidden<% } %>" data-card-id="<%- srcDigitalCardId %>">' +
                    '<input type="radio" id="cardList_<%- cardCount %>" name="cardList" value="<%- srcDigitalCardId %>" class="card-radio" <% if (isSelected) { %> checked <% } %> />' +
                    '<label for="cardList_<%- cardCount %>">' +
                        '<img src="<%- digitalCardData.artUri %>" alt="<%- digitalCardData.descriptorName %>" class="card-image"/>' +
                        '<div class="text-container">' +
                            '<h3 class="card-title"><%- digitalCardData.descriptorName %></h3>' +
                            '<p class="card-description">**** <%- panLastFour %></p>' +
                        '</div>' +
                    '</label>' +
                '</li>',
            showMoreCardsTemplate: 
                '<button type="button" class="c2p-show-more-cards-btn"><%= t("c2p_show_more_cards", [hiddenCardCount]) %></button>',
            enterCardManualyBtnTemplate:
                '<hr>' +
                '<li class="c2p_card">' +
                    '<input type="radio" id="cardList_<%- cardCount %>" name="cardList" value="manual_entry" class="card-radio" <% if (isSelected) { %> checked <% } %> />' +
                    '<label for="cardList_<%- cardCount %>">' +
                        '<div class="text-container">' +
                            '<h3 class="card-title"><%= t("c2p_enter_card_manually") %></h3>' +
                        '</div>' +
                    '</label>' +
                '</li>'
        },
        preselectEnterCardManually: false
    };

    c2pCardList.init = function(options, cards) {
        var $container = app.pluginOpts.c2pCardList && app.pluginOpts.c2pCardList.containerSelector ? $(app.pluginOpts.c2pCardList.containerSelector) : $('.PMINFO');
        c2pCardList.options = $.extend(true, {}, defaults, options);
        
        var $wrapper = $(_.template(c2pCardList.options.templates.wrapper)());
        
        $('#c2p_card_list_wrapper').remove();
        $container.prepend($wrapper);
        c2pCardList.$wrapper = $wrapper;

        c2pCardList.options.numberOfVisibleCards = c2pCardList.options.numberOfVisibleCards < 1 ? 1 : c2pCardList.options.numberOfVisibleCards;
        c2pCardList.$wrapper.html(_.template(c2pCardList.options.templates.cardsTemplate)());
        c2pCardList.updateCards(cards);
    };

    c2pCardList.updateCards = function(cards) {
        cards = cards || [];
        var $cardList = c2pCardList.$wrapper.find('#c2p_cards_list');
        $cardList.empty();
        var cardCount = 0;
        var hiddenCardCount = 0;
        var preselectedCardId = null;
        var notYouHtml = _.template(c2pCardList.options.templates.notYouBtnTemplate)();

        c2pCardList.$wrapper.find('.c2p-not-you-recognized-wrapper').remove();
        c2pCardList.$wrapper.prepend(notYouHtml);

        cards.forEach(function(card) {
            if (++cardCount > c2pCardList.options.numberOfVisibleCards) {
                card.isHidden = true;
                hiddenCardCount++;
            }
            
            if (c2pCardList.options.preselectEnterCardManually) {
                preselectedCardId = "manual_entry";
            }
            else if (cardCount === 1) {
                card.isSelected = true;
                preselectedCardId = card.srcDigitalCardId;
            }
            
            var cardHtml = _.template(c2pCardList.options.templates.cardTemplate)({
                srcDigitalCardId: card.srcDigitalCardId,
                panLastFour: card.panLastFour,
                digitalCardData: card.digitalCardData,
                isHidden: card.isHidden,
                isSelected: card.isSelected,
                cardCount: cardCount
            });
            $cardList.append(cardHtml);
        });

        if (hiddenCardCount > 0) {
            var showMoreCardsHtml = _.template(c2pCardList.options.templates.showMoreCardsTemplate)({hiddenCardCount: hiddenCardCount});
            $cardList.append(showMoreCardsHtml);
            $cardList.find('.c2p-show-more-cards-btn').on('click', function() {
                $cardList.find('.c2p_card.hidden').removeClass('hidden');
                $(this).remove();
                app.recalcUserDetailsArea();
            });
        }

        $cardList.append(_.template(c2pCardList.options.templates.enterCardManualyBtnTemplate)({cardCount: cardCount + 1, isSelected: c2pCardList.options.preselectEnterCardManually}));
        pubsub.publish('app.event.c2pCardList.CardChanged', [{ selectedCardId: preselectedCardId, isAutoSelected: true }]);

        c2pCardList.$wrapper.on('change', 'input[type="radio"][name="cardList"]', function() {
            var selectedCardId = $(this).val();
            pubsub.publish('app.event.c2pCardList.CardChanged', [{ selectedCardId: selectedCardId }]);
        });
        c2pCardList.$wrapper.find('.c2p-not-you-recognized-btn').on('click', function() {
            pubsub.publish('app.event.c2pCardList.NotYouClicked', [{}]);
        });
    };

    return {
        init: c2pCardList.init,
        updateCards: c2pCardList.updateCards
    };
})();